import { render, staticRenderFns } from "./GroupConfig.vue?vue&type=template&id=9988a820&scoped=true&lang=pug&"
import script from "./GroupConfig.vue?vue&type=script&lang=js&"
export * from "./GroupConfig.vue?vue&type=script&lang=js&"
import style0 from "./GroupConfig.vue?vue&type=style&index=0&id=9988a820&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9988a820",
  null
  
)

export default component.exports